/* eslint-disable */

/* THIS FILE IS AUTOGENERATED. */


export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: string;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /** GraphQL type for an integer that must be equal or greater than zero. */
  PositiveInt: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export type AccountInterface = {
  __typename: 'AccountInterface';
  id: Scalars['ID'];
  user: UserInterface;
};

export type AccountUserDetailsMutationInput = {
  billingAddress1: Scalars['String'];
  billingAddress2?: InputMaybe<Scalars['String']>;
  billingCity: Scalars['String'];
  billingCompanyName?: InputMaybe<Scalars['String']>;
  billingCountry: Scalars['String'];
  billingPostcode: Scalars['String'];
  billingState?: InputMaybe<Scalars['String']>;
  /** Optional VAT number to be specified on the invoice. */
  billingVatNumber?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** Send me the occasional email */
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  fullName: Scalars['String'];
};

/** Cart mutation that works on the current user in session. */
export type AccountUserDetailsMutationPayload = {
  __typename: 'AccountUserDetailsMutationPayload';
  billingAddress1: Scalars['String'];
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Scalars['String'];
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Scalars['String'];
  billingPostcode: Scalars['String'];
  billingState: Maybe<Scalars['String']>;
  /** Optional VAT number to be specified on the invoice. */
  billingVatNumber: Maybe<Scalars['String']>;
  clientMutationId: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** Send me the occasional email */
  emailOptIn: Maybe<Scalars['Boolean']>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  fullName: Scalars['String'];
  user: Maybe<UserInterface>;
};

export type ApplySharedCartMutation = {
  __typename: 'ApplySharedCartMutation';
  cart: Maybe<CartInterface>;
};

export type AwardInterface = {
  __typename: 'AwardInterface';
  customFonts: Array<CustomFontInterface>;
  /** Projects where Klim’s contribution was significant and/or essential. */
  essentialContribution: Scalars['Boolean'];
  fontFamilies: Array<FontFamilyInterface>;
  fontFamilyGroups: Array<FontFamilyGroupInterface>;
  id: Scalars['ID'];
  /** The HTML tag <ordn>th</ordn> can be used to apply ordinals. */
  name: Scalars['String'];
  /** Can be left empty as long as at least one font family group or font family or custom font is selected below. */
  receivedFor: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  year: Scalars['Int'];
};

export type BigSpecimenSet = {
  __typename: 'BigSpecimenSet';
  fontSize: Scalars['Float'];
  fontStyles: Array<FontStyleWithWords>;
  letterSpacing: Scalars['Float'];
  lineHeight: Scalars['Float'];
  referenceWordCalculatedWidth: Scalars['Int'];
  /** How many specimens are displayed for each font style within the font family. Can be set to 0, which will mean no specimens will show at all. */
  specimensPerFontStyle: Scalars['Int'];
};

export type BlogIndexPage = PageInterface & {
  __typename: 'BlogIndexPage';
  aliasOf: Maybe<Page>;
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  goLiveAt: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  lockedBy: Maybe<UserInterface>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type BlogIndexPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogIndexPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogIndexPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogIndexPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogIndexPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogIndexPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type BlogPage = PageInterface & {
  __typename: 'BlogPage';
  aliasOf: Maybe<Page>;
  ancestors: Array<PageInterface>;
  author: Maybe<Scalars['String']>;
  blurb: Maybe<Scalars['String']>;
  blurbImage: CustomImage;
  body: Maybe<Array<Maybe<StreamFieldInterface>>>;
  categories: Array<BlogTag>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  feedImage: Maybe<CustomImage>;
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  fontFamilyGroups: Maybe<Array<FontFamilyGroupInterface>>;
  goLiveAt: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  hero: Maybe<Array<Maybe<StreamFieldInterface>>>;
  id: Maybe<Scalars['ID']>;
  intro: Maybe<Scalars['String']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  lockedBy: Maybe<UserInterface>;
  nextSiblings: Array<PageInterface>;
  noindex: Scalars['Boolean'];
  numchild: Scalars['Int'];
  owner: Maybe<UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  path: Scalars['String'];
  postDate: Scalars['DateTime'];
  previousSiblings: Array<PageInterface>;
  relatedBlogPosts: Array<BlogPage>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type BlogPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagecategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagerelatedBlogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type BlogPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type BlogTag = {
  __typename: 'BlogTag';
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type CampaignImageInterface = {
  __typename: 'CampaignImageInterface';
  /** Background colour */
  colorBackground: Maybe<Scalars['String']>;
  /** Loader progress bar background colour. */
  colorLoaderBackground: Maybe<Scalars['String']>;
  /** Loader progress bar foreground colour. */
  colorLoaderForeground: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  /** An image of at least 4000px wide, ideally. Or an SVG. */
  imageLandscape: Scalars['String'];
  imageLandscapeHeight: Scalars['Int'];
  imageLandscapeWidth: Scalars['Int'];
  /** An alternate portrait image of at least 4000px high, ideally. Or an SVG. */
  imagePortrait: Maybe<Scalars['String']>;
  imagePortraitHeight: Maybe<Scalars['Int']>;
  imagePortraitWidth: Maybe<Scalars['Int']>;
  layoutModeLandscape: CampaignLayoutMode;
  layoutModePortrait: CampaignLayoutMode;
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapLandscape: Scalars['Int'];
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['DateTime'];
  sortOrder: Scalars['Int'];
};

export type CampaignInterface = {
  __typename: 'CampaignInterface';
  created: Scalars['DateTime'];
  displayMode: CampaignsCampaignDisplayModeChoices;
  fontfamilySet: Array<FontFamilyInterface>;
  id: Scalars['ID'];
  images: Array<CampaignImageInterface>;
  modified: Scalars['DateTime'];
  /** When enabled, any heading SVG will show overlaid on top of the campaign media, as opposed to below it. */
  svgHeadingOverlay: Scalars['Boolean'];
  /** In milliseconds. */
  transitionDuration: Scalars['Int'];
  /** In milliseconds. Time between transitions. */
  transitionInterval: Scalars['Int'];
  type: CampaignsCampaignTypeChoices;
  videos: Array<CampaignVideoInterface>;
};

/** Campaign layout mode */
export enum CampaignLayoutMode {
  FULL_WIDTH = 'FULL_WIDTH',
  WITHIN_GRID = 'WITHIN_GRID'
}

export type CampaignVideoInterface = {
  __typename: 'CampaignVideoInterface';
  /** Loader progress bar background colour. */
  colorLoaderBackground: Maybe<Scalars['String']>;
  /** Loader progress bar foreground colour. */
  colorLoaderForeground: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  layoutModeLandscape: CampaignLayoutMode;
  layoutModePortrait: CampaignLayoutMode;
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapLandscape: Scalars['Int'];
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['DateTime'];
  videoLandscape: VimeoVideoInterface;
  videoPortrait: Maybe<VimeoVideoInterface>;
};

/** An enumeration. */
export enum CampaignsCampaignDisplayModeChoices {
  /** Cross-fade (as ordered) */
  CROSS_FADE = 'CROSS_FADE',
  /** Cross-fade (random order) */
  CROSS_FADE_RANDOM = 'CROSS_FADE_RANDOM',
  /** Random image or video on load */
  RANDOM_SINGLE = 'RANDOM_SINGLE'
}

/** An enumeration. */
export enum CampaignsCampaignTypeChoices {
  /** Image */
  IMAGE = 'IMAGE',
  /** Video */
  VIDEO = 'VIDEO'
}

/**
 * Mutation that creates/updates a Stripe PaymentIntent and returns a client secret
 * that enables Stripe.js to put a payment transaction through.
 */
export type CartGetStripeClientSecret = {
  __typename: 'CartGetStripeClientSecret';
  cart: Maybe<CartInterface>;
  clientSecret: Maybe<Scalars['String']>;
  invoiceIsPaid: Maybe<Scalars['Boolean']>;
};

export type CartInterface = {
  __typename: 'CartInterface';
  /** Subtotal, expressed in the cart base currency */
  amountSubtotal: Scalars['Float'];
  /** Subtotal, expressed in cart currency */
  amountSubtotalConverted: Scalars['Float'];
  /** Subtotal of all fonts with licence multipliers, expressed in the cart base currency */
  amountSubtotalForFontsWithLicenceMultiplier: Scalars['Float'];
  /** Tax in cart final currency */
  amountTax: Scalars['Float'];
  /** Tax in USD */
  amountTaxUsd: Scalars['Float'];
  /** Total in cart currency */
  amountTotal: Scalars['Float'];
  /** Total in USD */
  amountTotalUsd: Scalars['Float'];
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Maybe<Scalars['String']>;
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Maybe<CountryChoices>;
  /** Person to direct the invoice to */
  billingName: Maybe<Scalars['String']>;
  billingPostcode: Maybe<Scalars['String']>;
  /** Optional P/O to be specified on the invoice. */
  billingPurchaseOrder: Maybe<Scalars['String']>;
  billingState: Maybe<Scalars['String']>;
  /** Optional VAT number to be specified on the invoice. */
  billingVatNumber: Maybe<Scalars['String']>;
  currency: Maybe<CurrencyChoices>;
  discounts: Array<DiscountInterface>;
  emailOptIn: Scalars['Boolean'];
  exchangeRate: Scalars['Float'];
  hasDownloadables: Scalars['Boolean'];
  hasFontlessItems: Scalars['Boolean'];
  hasSimpleLicensing: Scalars['Boolean'];
  id: Scalars['ID'];
  invoiceExtraDescription: Maybe<Scalars['String']>;
  invoiceId: Maybe<Scalars['ID']>;
  invoiceNumber: Maybe<Scalars['String']>;
  /** Lets us know whether the cart is for a Quote or Invoice */
  isInvoice: Scalars['Boolean'];
  items: Array<LineItemInterface>;
  /** Legacy field, for reference only. */
  legacyBillingAddress: Maybe<Scalars['String']>;
  /** Legacy field, for reference only. */
  legacyLicensedTo: Maybe<Scalars['String']>;
  licenceTiers: Array<CartTierInterface>;
  /** When checked the licensee of the purchase can be specified in the "Licensee" fields. If not checked the billing details will determine the licensee. */
  licensedForSomeoneElse: Scalars['Boolean'];
  licensedToAddress1: Maybe<Scalars['String']>;
  licensedToAddress2: Maybe<Scalars['String']>;
  licensedToCity: Maybe<Scalars['String']>;
  licensedToCompanyName: Maybe<Scalars['String']>;
  licensedToCountry: Maybe<CountryChoices>;
  licensedToPostcode: Maybe<Scalars['String']>;
  licensedToState: Maybe<Scalars['String']>;
  licensedToVatNumber: Maybe<Scalars['String']>;
  nativeCurrency: Maybe<CurrencyChoices>;
  refundedAmount: Scalars['Float'];
  taxRate: Scalars['Float'];
  userEmail: Maybe<Scalars['String']>;
  /** Inverse of usesNativeCurrency. */
  usesCurrencyConversion: Scalars['Boolean'];
  /** Whether the amounts in this cart are expressed in the native currency (e.g. GBP) or, if not, then they are expressed in USD and the final total is converted to e.g. GBP. */
  usesNativeCurrency: Scalars['Boolean'];
};

export type CartSetBillingCountryMutationInput = {
  billingCountry: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
};

export type CartSetBillingCountryMutationPayload = {
  __typename: 'CartSetBillingCountryMutationPayload';
  billingCountry: CountryChoices;
  cart: CartInterface;
  clientMutationId: Maybe<Scalars['String']>;
  errors: Array<ErrorType>;
};

export type CartSetCheckoutDetailsMutationInput = {
  billingAddress1: Scalars['String'];
  billingAddress2?: InputMaybe<Scalars['String']>;
  billingCity: Scalars['String'];
  billingCompanyName: Scalars['String'];
  billingCountry: Scalars['String'];
  /** Person to direct the invoice to */
  billingName: Scalars['String'];
  billingPostcode: Scalars['String'];
  billingState?: InputMaybe<Scalars['String']>;
  /** Optional VAT number to be specified on the invoice. */
  billingVatNumber?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** When checked the licensee of the purchase can be specified in the "Licensee" fields. If not checked the billing details will determine the licensee. */
  licensedForSomeoneElse?: InputMaybe<Scalars['Boolean']>;
  licensedToAddress1?: InputMaybe<Scalars['String']>;
  licensedToAddress2?: InputMaybe<Scalars['String']>;
  licensedToCity?: InputMaybe<Scalars['String']>;
  licensedToCompanyName?: InputMaybe<Scalars['String']>;
  licensedToCountry?: InputMaybe<Scalars['String']>;
  licensedToPostcode?: InputMaybe<Scalars['String']>;
  licensedToState?: InputMaybe<Scalars['String']>;
  licensedToVatNumber?: InputMaybe<Scalars['String']>;
  userEmail: Scalars['String'];
};

export type CartSetCheckoutDetailsMutationPayload = {
  __typename: 'CartSetCheckoutDetailsMutationPayload';
  billingCountry: CountryChoices;
  cart: CartInterface;
  clientMutationId: Maybe<Scalars['String']>;
  errors: Array<ErrorType>;
};

export type CartSetExtraTierFieldsMutation = {
  __typename: 'CartSetExtraTierFieldsMutation';
  cart: Maybe<CartInterface>;
  errors: Maybe<Array<TierExtraFieldErrorType>>;
  invoiceIsPaid: Maybe<Scalars['Boolean']>;
};

export type CartTierInterface = {
  __typename: 'CartTierInterface';
  /** The filename of the licence contract pertaining to this licence type for this sale. */
  contractDetails: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** For Web this is the domain name, for App this is the app name. */
  licenceSubject: Maybe<Scalars['String']>;
  tier: TierInterface;
};

/**
 * This mutation will ensure that the current session cart has exactly
 * the fonts and licences that were passed as arguments. I.e. the entire cart
 * item/licence state is represented by the arguments.
 */
export type CartUpdateMutation = {
  __typename: 'CartUpdateMutation';
  cart: CartInterface;
};

/** Collection type */
export type CollectionObjectType = {
  __typename: 'CollectionObjectType';
  ancestors: Array<Maybe<CollectionObjectType>>;
  depth: Scalars['Int'];
  descendants: Array<Maybe<CollectionObjectType>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  numchild: Scalars['Int'];
  path: Scalars['String'];
};

export type ColorSchemeInterface = {
  __typename: 'ColorSchemeInterface';
  colorBackground: Scalars['String'];
  colorBackgroundAlt: Maybe<Scalars['String']>;
  colorForeground: Scalars['String'];
  colorForegroundAlt: Maybe<Scalars['String']>;
  colorHighlight: Scalars['String'];
  colorHighlightAlt: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** An enumeration. */
export enum CountryChoices {
  /** Ascension Island */
  AC = 'AC',
  /** Andorra */
  AD = 'AD',
  /** United Arab Emirates */
  AE = 'AE',
  /** Afghanistan */
  AF = 'AF',
  /** Antigua and Barbuda */
  AG = 'AG',
  /** Anguilla */
  AI = 'AI',
  /** Albania */
  AL = 'AL',
  /** Armenia */
  AM = 'AM',
  /** Angola */
  AO = 'AO',
  /** Antarctica */
  AQ = 'AQ',
  /** Argentina */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Austria */
  AT = 'AT',
  /** Australia */
  AU = 'AU',
  /** Aruba */
  AW = 'AW',
  /** Finland (Åland Islands) */
  AX = 'AX',
  /** Azerbaijan */
  AZ = 'AZ',
  /** Bosnia and Herzegovina */
  BA = 'BA',
  /** Barbados */
  BB = 'BB',
  /** Bangladesh */
  BD = 'BD',
  /** Belgium */
  BE = 'BE',
  /** Burkina Faso */
  BF = 'BF',
  /** Bulgaria (Republic) */
  BG = 'BG',
  /** Bahrain */
  BH = 'BH',
  /** Burundi */
  BI = 'BI',
  /** Benin */
  BJ = 'BJ',
  /** Saint Barthelemy */
  BL = 'BL',
  /** Bermuda */
  BM = 'BM',
  /** Brunei Darussalam */
  BN = 'BN',
  /** Bolivia */
  BO = 'BO',
  /** Bonaire, Sint Eustatius, and Saba */
  BQ = 'BQ',
  /** Brazil */
  BR = 'BR',
  /** Bahamas */
  BS = 'BS',
  /** Bhutan */
  BT = 'BT',
  /** Bouvet Island */
  BV = 'BV',
  /** Botswana */
  BW = 'BW',
  /** Belarus */
  BY = 'BY',
  /** Belize */
  BZ = 'BZ',
  /** Canada */
  CA = 'CA',
  /** Cocos (Keeling) Islands */
  CC = 'CC',
  /** Congo (Dem. Republic) */
  CD = 'CD',
  /** Central African Republic */
  CF = 'CF',
  /** Congo (Republic) */
  CG = 'CG',
  /** Switzerland */
  CH = 'CH',
  /** Cote D’Ivoire */
  CI = 'CI',
  /** Cook Islands */
  CK = 'CK',
  /** Chile */
  CL = 'CL',
  /** Cameroon */
  CM = 'CM',
  /** China */
  CN = 'CN',
  /** Colombia */
  CO = 'CO',
  /** Costa Rica */
  CR = 'CR',
  /** Cuba */
  CU = 'CU',
  /** Cape Verde */
  CV = 'CV',
  /** Curaçao */
  CW = 'CW',
  /** Christmas Island */
  CX = 'CX',
  /** Cyprus */
  CY = 'CY',
  /** Czech Republic */
  CZ = 'CZ',
  /** Germany */
  DE = 'DE',
  /** Djibouti */
  DJ = 'DJ',
  /** Denmark */
  DK = 'DK',
  /** Dominica */
  DM = 'DM',
  /** Dominican Republic */
  DO = 'DO',
  /** Algeria */
  DZ = 'DZ',
  /** Ecuador */
  EC = 'EC',
  /** Estonia */
  EE = 'EE',
  /** Egypt */
  EG = 'EG',
  /** Western Sahara */
  EH = 'EH',
  /** Eritrea */
  ER = 'ER',
  /** Spain */
  ES = 'ES',
  /** Ethiopia */
  ET = 'ET',
  /** Finland */
  FI = 'FI',
  /** Fiji */
  FJ = 'FJ',
  /** Falkland Islands (Malvinas) */
  FK = 'FK',
  /** Micronesia (Federated State of) */
  FM = 'FM',
  /** Faroe Islands */
  FO = 'FO',
  /** France */
  FR = 'FR',
  /** Gabon */
  GA = 'GA',
  /** United Kingdom */
  GB = 'GB',
  /** Grenada (West Indies) */
  GD = 'GD',
  /** Georgia */
  GE = 'GE',
  /** French Guiana */
  GF = 'GF',
  /** Channel Islands (Guernsey) */
  GG = 'GG',
  /** Ghana */
  GH = 'GH',
  /** Gibraltar */
  GI = 'GI',
  /** Greenland */
  GL = 'GL',
  /** Gambia */
  GM = 'GM',
  /** Guinea */
  GN = 'GN',
  /** Guadeloupe */
  GP = 'GP',
  /** Equatorial Guinea */
  GQ = 'GQ',
  /** Greece */
  GR = 'GR',
  /** South Georgia */
  GS = 'GS',
  /** Guatemala */
  GT = 'GT',
  /** Guam */
  GU = 'GU',
  /** Guinea-Bissau */
  GW = 'GW',
  /** Guyana */
  GY = 'GY',
  /** Hong Kong */
  HK = 'HK',
  /** Heard and McDonald Islands */
  HM = 'HM',
  /** Honduras */
  HN = 'HN',
  /** Croatia */
  HR = 'HR',
  /** Haiti */
  HT = 'HT',
  /** Hungary (Republic) */
  HU = 'HU',
  /** Indonesia */
  ID = 'ID',
  /** Ireland */
  IE = 'IE',
  /** Israel */
  IL = 'IL',
  /** Isle of Man */
  IM = 'IM',
  /** India */
  IN = 'IN',
  /** British Indian Ocean Territory */
  IO = 'IO',
  /** Iraq */
  IQ = 'IQ',
  /** Iran */
  IR = 'IR',
  /** Iceland */
  IS = 'IS',
  /** Italy */
  IT = 'IT',
  /** Channel Islands (Jersey) */
  JE = 'JE',
  /** Jamaica */
  JM = 'JM',
  /** Jordan */
  JO = 'JO',
  /** Japan */
  JP = 'JP',
  /** Kenya */
  KE = 'KE',
  /** Kyrgyzstan */
  KG = 'KG',
  /** Cambodia */
  KH = 'KH',
  /** Kiribati */
  KI = 'KI',
  /** Comoros */
  KM = 'KM',
  /** Saint Kitts and Nevis */
  KN = 'KN',
  /** North Korea */
  KP = 'KP',
  /** South Korea */
  KR = 'KR',
  /** Kuwait */
  KW = 'KW',
  /** Cayman Islands */
  KY = 'KY',
  /** Kazakhstan */
  KZ = 'KZ',
  /** Lao (People’s Dem. Republic) */
  LA = 'LA',
  /** Lebanon */
  LB = 'LB',
  /** Saint Lucia */
  LC = 'LC',
  /** Liechtenstein */
  LI = 'LI',
  /** Sri Lanka */
  LK = 'LK',
  /** Liberia */
  LR = 'LR',
  /** Lesotho */
  LS = 'LS',
  /** Lithuania */
  LT = 'LT',
  /** Luxembourg */
  LU = 'LU',
  /** Latvia */
  LV = 'LV',
  /** Libya */
  LY = 'LY',
  /** Morocco */
  MA = 'MA',
  /** Monaco */
  MC = 'MC',
  /** Moldova (Republic) */
  MD = 'MD',
  /** Montenegro */
  ME = 'ME',
  /** Saint Martin */
  MF = 'MF',
  /** Madagascar */
  MG = 'MG',
  /** Marshall Islands */
  MH = 'MH',
  /** Macedonia */
  MK = 'MK',
  /** Mali */
  ML = 'ML',
  /** Myanmar */
  MM = 'MM',
  /** Mongolia */
  MN = 'MN',
  /** Macao */
  MO = 'MO',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** Martinique */
  MQ = 'MQ',
  /** Mauritania */
  MR = 'MR',
  /** Montserrat */
  MS = 'MS',
  /** Malta */
  MT = 'MT',
  /** Mauritius */
  MU = 'MU',
  /** Maldives */
  MV = 'MV',
  /** Malawi */
  MW = 'MW',
  /** Mexico */
  MX = 'MX',
  /** Malaysia */
  MY = 'MY',
  /** Mozambique */
  MZ = 'MZ',
  /** Namibia */
  NA = 'NA',
  /** New Caledonia */
  NC = 'NC',
  /** Niger */
  NE = 'NE',
  /** Norfolk Island */
  NF = 'NF',
  /** Nigeria */
  NG = 'NG',
  /** Nicaragua */
  NI = 'NI',
  /** Netherlands */
  NL = 'NL',
  /** Norway */
  NO = 'NO',
  /** Nepal */
  NP = 'NP',
  /** Nauru Central Pacific */
  NR = 'NR',
  /** Niue */
  NU = 'NU',
  /** New Zealand */
  NZ = 'NZ',
  /** Oman */
  OM = 'OM',
  /** Panama (Republic) */
  PA = 'PA',
  /** Peru */
  PE = 'PE',
  /** French Polynesia */
  PF = 'PF',
  /** Papua New Guinea */
  PG = 'PG',
  /** Philippines */
  PH = 'PH',
  /** Pakistan */
  PK = 'PK',
  /** Poland */
  PL = 'PL',
  /** St. Pierre and Miquelon */
  PM = 'PM',
  /** Pitcairn */
  PN = 'PN',
  /** Puerto Rico */
  PR = 'PR',
  /** Palestinian Territory */
  PS = 'PS',
  /** Portugal */
  PT = 'PT',
  /** Palau */
  PW = 'PW',
  /** Paraguay */
  PY = 'PY',
  /** Qatar */
  QA = 'QA',
  /** Reunion */
  RE = 'RE',
  /** Romania */
  RO = 'RO',
  /** Serbia (Republic) */
  RS = 'RS',
  /** Russian Federation */
  RU = 'RU',
  /** Rwanda */
  RW = 'RW',
  /** Saudi Arabia */
  SA = 'SA',
  /** Solomon Islands */
  SB = 'SB',
  /** Seychelles */
  SC = 'SC',
  /** Sudan */
  SD = 'SD',
  /** Sweden */
  SE = 'SE',
  /** Singapore (Republic) */
  SG = 'SG',
  /** Saint Helena */
  SH = 'SH',
  /** Slovenia */
  SI = 'SI',
  /** Svalbard and Jan Mayen Islands */
  SJ = 'SJ',
  /** Slovakia */
  SK = 'SK',
  /** Sierra Leone */
  SL = 'SL',
  /** San Marino */
  SM = 'SM',
  /** Senegal */
  SN = 'SN',
  /** Somalia */
  SO = 'SO',
  /** Suriname */
  SR = 'SR',
  /** South Sudan */
  SS = 'SS',
  /** Sao Tome and Principe */
  ST = 'ST',
  /** El Salvador */
  SV = 'SV',
  /** Sint Maarten */
  SX = 'SX',
  /** Syria */
  SY = 'SY',
  /** Swaziland */
  SZ = 'SZ',
  /** Tristan Da Cunha */
  TA = 'TA',
  /** Turks and Caicos Islands */
  TC = 'TC',
  /** Chad */
  TD = 'TD',
  /** French Southern Territories */
  TF = 'TF',
  /** Togo */
  TG = 'TG',
  /** Thailand */
  TH = 'TH',
  /** Tajikistan */
  TJ = 'TJ',
  /** Tokelau */
  TK = 'TK',
  /** Timor-Leste */
  TL = 'TL',
  /** Turkmenistan */
  TM = 'TM',
  /** Tunisia */
  TN = 'TN',
  /** Tonga */
  TO = 'TO',
  /** Turkey */
  TR = 'TR',
  /** Trinidad and Tobago */
  TT = 'TT',
  /** Tuvalu */
  TV = 'TV',
  /** Taiwan */
  TW = 'TW',
  /** Tanzania (United Republic) */
  TZ = 'TZ',
  /** Ukraine */
  UA = 'UA',
  /** Uganda */
  UG = 'UG',
  /** United States Minor Outlying Islands */
  UM = 'UM',
  /** United States */
  US = 'US',
  /** Uruguay */
  UY = 'UY',
  /** Uzbekistan */
  UZ = 'UZ',
  /** Vatican */
  VA = 'VA',
  /** Saint Vincent and the Grenadines (Antilles) */
  VC = 'VC',
  /** Venezuela */
  VE = 'VE',
  /** Virgin Islands (British) */
  VG = 'VG',
  /** Virgin Islands (U.S.) */
  VI = 'VI',
  /** Viet Nam */
  VN = 'VN',
  /** Vanuatu */
  VU = 'VU',
  /** Wallis and Futuna Islands */
  WF = 'WF',
  /** Samoa */
  WS = 'WS',
  /** Kosovo */
  XK = 'XK',
  /** Yemen */
  YE = 'YE',
  /** Mayotte */
  YT = 'YT',
  /** South Africa */
  ZA = 'ZA',
  /** Zambia */
  ZM = 'ZM',
  /** Zimbabwe */
  ZW = 'ZW'
}

/** Represents information needed to render a particular style in CSS. */
export type CssRenderInfo = {
  __typename: 'CssRenderInfo';
  fontFamilyName: Scalars['String'];
  isItalic: Scalars['Boolean'];
  variableAxisValues: Maybe<Array<FontVariationInstanceAxisValueInterface>>;
};

/** An enumeration. */
export enum CurrencyChoices {
  /** AUD – Australian Dollar */
  AUD = 'AUD',
  /** CAD – Canadian Dollar */
  CAD = 'CAD',
  /** CHF – Swiss Franc */
  CHF = 'CHF',
  /** CNY – Chinese Yuan */
  CNY = 'CNY',
  /** DKK – Danish Krone */
  DKK = 'DKK',
  /** EUR – Euro */
  EUR = 'EUR',
  /** GBP – Pound Sterling */
  GBP = 'GBP',
  /** JPY – Japanese Yen */
  JPY = 'JPY',
  /** NOK – Norwegian Krone */
  NOK = 'NOK',
  /** NZD – New Zealand Dollar */
  NZD = 'NZD',
  /** SEK – Swedish Krona */
  SEK = 'SEK',
  /** USD – US Dollar */
  USD = 'USD'
}

export type CustomFontFamilyInterface = {
  __typename: 'CustomFontFamilyInterface';
  id: Scalars['ID'];
  /** E.g. PayPal Sans Big or PayPal Sans Small */
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  styles: Array<CustomFontStyleInterface>;
  svg: Maybe<Scalars['String']>;
};

export type CustomFontImageInterface = {
  __typename: 'CustomFontImageInterface';
  /** When checked this image will be highlighted in the design */
  feature: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The higher the resolution, the better. */
  image: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type CustomFontInterface = {
  __typename: 'CustomFontInterface';
  awards: Array<AwardInterface>;
  /** If the heading image isn't vector then a bitmap can be selected here instead. */
  bitmapHeading: Maybe<Scalars['String']>;
  colorBackground: Scalars['String'];
  colorForeground: Scalars['String'];
  colorHighlight: Scalars['String'];
  creditAgency: Array<Scalars['String']>;
  creditClient: Array<Scalars['String']>;
  creditCollaborators: Array<Scalars['String']>;
  creditDesign: Array<Scalars['String']>;
  /** 'Continue Reading' link of Information section */
  designInformationPage: Maybe<BlogPage>;
  families: Array<CustomFontFamilyInterface>;
  id: Scalars['ID'];
  images: Array<CustomFontImageInterface>;
  informationIntro: Maybe<Scalars['String']>;
  isPreRelease: Scalars['Boolean'];
  name: Scalars['String'];
  /** The recommended max length is 160 characters, but this is not enforced. */
  seoDescription: Scalars['String'];
  /** A 1200x630 image to use as a preview when the font’s link is shared (e.g. on social media). */
  seoImage: Scalars['String'];
  /** Recommended limit of 60 characters, hard limit of 255 characters. If no custom title is provided one will be constructed. */
  seoTitle: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  specimens: Array<CustomFontSpecimenInterface>;
  styles: Array<CustomFontStyleInterface>;
  svgHeading: Maybe<Scalars['String']>;
  svgNavigation: Maybe<Scalars['String']>;
};

export type CustomFontSpecimenInterface = {
  __typename: 'CustomFontSpecimenInterface';
  /** If the image isn't vector then a bitmap can be selected here instead. */
  bitmap: Maybe<Scalars['String']>;
  family: Maybe<CustomFontFamilyInterface>;
  id: Scalars['ID'];
  /** E.g. 'Regular' or 'Regular Italic' */
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  svg: Maybe<Scalars['String']>;
};

export type CustomFontStyleInterface = {
  __typename: 'CustomFontStyleInterface';
  family: Maybe<CustomFontFamilyInterface>;
  id: Scalars['ID'];
  /** E.g. 'Regular' or 'Regular Italic' */
  name: Scalars['String'];
  svg: Scalars['String'];
  /** Styles will be ordered by this. */
  weight: Scalars['Int'];
};

export type CustomImage = {
  __typename: 'CustomImage';
  aspectRatio: Scalars['Float'];
  collection: CollectionObjectType;
  createdAt: Scalars['DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize: Maybe<Scalars['Int']>;
  focalPointHeight: Maybe<Scalars['Int']>;
  focalPointWidth: Maybe<Scalars['Int']>;
  focalPointX: Maybe<Scalars['Int']>;
  focalPointY: Maybe<Scalars['Int']>;
  hasAlpha: Maybe<Scalars['Boolean']>;
  height: Scalars['Int'];
  id: Maybe<Scalars['ID']>;
  isSvg: Scalars['Boolean'];
  placeholderColor: Maybe<Scalars['String']>;
  rendition: Maybe<CustomRendition>;
  sizes: Scalars['String'];
  /** @deprecated Use the `url` attribute */
  src: Scalars['String'];
  srcSet: Maybe<Scalars['String']>;
  tags: Array<TagObjectType>;
  title: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Int'];
};


export type CustomImagerenditionArgs = {
  bgcolor?: InputMaybe<Scalars['String']>;
  fill?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  jpegquality?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  webpquality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CustomImagesrcSetArgs = {
  format?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CustomRendition = {
  __typename: 'CustomRendition';
  alt: Scalars['String'];
  backgroundPositionStyle: Scalars['String'];
  file: Scalars['String'];
  filterSpec: Scalars['String'];
  focalPoint: Maybe<Scalars['String']>;
  focalPointKey: Scalars['String'];
  height: Scalars['Int'];
  id: Maybe<Scalars['ID']>;
  image: CustomImage;
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type DeleteSpecimenMutation = {
  __typename: 'DeleteSpecimenMutation';
  ok: Maybe<Scalars['Boolean']>;
};

export type DiscountInterface = {
  __typename: 'DiscountInterface';
  /** Discount in cart base currency */
  amount: Scalars['Float'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Discount in percentage of (subtotal minus fixed amount discounts) */
  percentage: Scalars['Int'];
  type: DiscountType;
};

/** Type of Discount */
export enum DiscountType {
  PACKAGE = 'PACKAGE',
  STANDARD = 'STANDARD'
}

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions: Maybe<Array<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql: Maybe<Array<Maybe<DjangoDebugSQL>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String'];
  /** The message of the exception */
  message: Scalars['String'];
  /** The stack trace */
  stack: Scalars['String'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSQL = {
  __typename: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type EnumErrorType = {
  __typename: 'EnumErrorType';
  field: Maybe<Scalars['String']>;
  messages: Maybe<Array<ErrorCode>>;
};

/** Error codes */
export enum ErrorCode {
  ACCOUNT_EXISTS_FOR_EMAIL = 'ACCOUNT_EXISTS_FOR_EMAIL',
  INVALID = 'INVALID',
  REQUIRED = 'REQUIRED',
  USER_IS_LOGGED_IN = 'USER_IS_LOGGED_IN'
}

export type ErrorType = {
  __typename: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export type FontFamilyGroupInterface = {
  __typename: 'FontFamilyGroupInterface';
  awards: Array<AwardInterface>;
  campaign: Maybe<CampaignInterface>;
  colorSchemes: Array<ColorSchemeInterface>;
  cssRenderInfo: CssRenderInfo;
  /** 'Continue Reading' link of Information section */
  designInformationPage: Maybe<BlogPage>;
  fontFamilies: Array<FontFamilyInterface>;
  fontProductType: FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<ProductFontIds>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  informationIntro: Maybe<Scalars['String']>;
  /** When checked this group will behave as a Collection. This means it can be seen as such on the site, can be purchased. */
  isCollection: Scalars['Boolean'];
  /** When checked this group show highlighted as 'New'. */
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  pdfSpecimen: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  /** The recommended max length is 160 characters, but this is not enforced. */
  seoDescription: Scalars['String'];
  /** A 1200x630 image to use as a preview when the font’s link is shared (e.g. on social media). */
  seoImage: Scalars['String'];
  /** Recommended limit of 60 characters, hard limit of 255 characters. If no custom title is provided one will be constructed. */
  seoTitle: Scalars['String'];
  /** When checked this group will be shown in the Custom Font menu, either as a Collection or as its individual families. */
  showInCustomFontMenu: Scalars['Boolean'];
  showOnHomepage: Scalars['Boolean'];
  slug: Scalars['String'];
  svgHeading: Maybe<Scalars['String']>;
  svgNavigation: Maybe<Scalars['String']>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
};

export type FontFamilyInterface = {
  __typename: 'FontFamilyInterface';
  awards: Array<AwardInterface>;
  classification: Array<Scalars['String']>;
  creditCollaborators: Array<Scalars['String']>;
  creditDesign: Array<Scalars['String']>;
  creditEngineering: Array<Scalars['String']>;
  cssRenderInfo: CssRenderInfo;
  featuredInUsePosts: Maybe<Array<PageInterface>>;
  fontFamilyGroup: FontFamilyGroupInterface;
  fontProductType: FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<ProductFontIds>;
  fontStyles: Array<FontStyleInterface>;
  fullName: Scalars['String'];
  hasVariableFonts: Scalars['Boolean'];
  id: Scalars['ID'];
  isPreRelease: Scalars['Boolean'];
  mainFontStyle: FontStyleInterface;
  mainSubfamily: Maybe<FontSubfamilyInterface>;
  name: Scalars['String'];
  notableDetails: Array<FontFamilyNotableDetailInterface>;
  opentypeSpecimens: Array<FontFamilyOpenTypeFeatureInterface>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  release: Maybe<Scalars['Date']>;
  /** The recommended max length is 160 characters, but this is not enforced. */
  seoDescription: Scalars['String'];
  /** A 1200x630 image to use as a preview when the font’s link is shared (e.g. on social media). */
  seoImage: Scalars['String'];
  /** Recommended limit of 60 characters, hard limit of 255 characters. If no custom title is provided one will be constructed. */
  seoTitle: Scalars['String'];
  slug: Scalars['String'];
  subfamilies: Array<FontSubfamilyInterface>;
  supportedLanguages: Array<Scalars['String']>;
  svgHeading: Maybe<Scalars['String']>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  vfItalicFiles: Maybe<FontFilesInterface>;
  vfRomanFiles: Maybe<FontFilesInterface>;
};


export type FontFamilyInterfacefeaturedInUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type FontFamilyNotableDetailInterface = {
  __typename: 'FontFamilyNotableDetailInterface';
  id: Scalars['ID'];
  svg: Scalars['String'];
};

export type FontFamilyOpenTypeFeatureInterface = {
  __typename: 'FontFamilyOpenTypeFeatureInterface';
  customDescription: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  specimen: SpecimenInterface;
  specimenShowAll: Maybe<SpecimenInterface>;
  type: SpecimenFontFamilyOpenTypeFeatureTypeChoices;
};

export type FontFamilyOpenTypeFeatureMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customDescription?: InputMaybe<Scalars['String']>;
  fontFamily: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  specimen: Scalars['ID'];
  specimenShowAll: Scalars['ID'];
  type: Scalars['String'];
};

export type FontFamilyOpenTypeFeatureMutationPayload = {
  __typename: 'FontFamilyOpenTypeFeatureMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  errors: Array<ErrorType>;
  fontFamilyOpenTypeFeature: Maybe<FontFamilyOpenTypeFeatureInterface>;
};

export type FontFilesInterface = {
  __typename: 'FontFilesInterface';
  created: Scalars['DateTime'];
  file: Scalars['String'];
  id: Scalars['ID'];
  metrics: FontMetricsInterface;
  modified: Scalars['DateTime'];
  testFile: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  versionNumber: Scalars['Decimal'];
  woff2File: Maybe<Scalars['String']>;
  woff2FileSize: Maybe<Scalars['Int']>;
  woff2TestFile: Maybe<Scalars['String']>;
  woffFile: Scalars['String'];
};

export type FontMetricsInterface = {
  __typename: 'FontMetricsInterface';
  ascentCalc: Scalars['Int'];
  ascentHhea: Scalars['Int'];
  ascentTypoOs2: Scalars['Int'];
  ascentWinOs2: Scalars['Int'];
  capHeightOs2: Scalars['Int'];
  created: Scalars['DateTime'];
  descentCalc: Scalars['Int'];
  descentHhea: Scalars['Int'];
  descentTypoOs2: Scalars['Int'];
  descentWinOs2: Scalars['Int'];
  id: Scalars['ID'];
  lineGapHhea: Scalars['Int'];
  lineGapTypoOs2: Scalars['Int'];
  modified: Scalars['DateTime'];
  unitsPerEmHead: Scalars['Int'];
  uuid: Scalars['UUID'];
  xHeightOs2: Scalars['Int'];
};

export type FontProductInput = {
  fontId: Scalars['ID'];
  fontProductType: FontProductTypeChoice;
};

export type FontProductInterface = {
  __typename: 'FontProductInterface';
  cssRenderInfo: CssRenderInfo;
  fontId: Scalars['ID'];
  fontProductType: FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleIdsByFamilyId: Array<ProductFontIds>;
  typographicRanking: Maybe<Scalars['Int']>;
};

/** Font product type */
export enum FontProductTypeChoice {
  FONTFAMILY = 'FONTFAMILY',
  FONTFAMILYGROUP = 'FONTFAMILYGROUP',
  FONTSTYLE = 'FONTSTYLE'
}

/** Full FontStyle interface for SSR API */
export type FontStyleInterface = {
  __typename: 'FontStyleInterface';
  cssRenderInfo: CssRenderInfo;
  fontProductType: FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<ProductFontIds>;
  fontSubfamily: Maybe<FontSubfamilyInterface>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  openTypeFeatures: Array<OpenTypeFeature>;
  otfFiles: Maybe<FontFilesInterface>;
  /** Recommended pixel size */
  pixelSize: Maybe<Scalars['Int']>;
  pointSize: Maybe<Scalars['Float']>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  stylisticSetCustomNames: Array<StylisticSetNameInterface>;
  ttfFiles: Maybe<FontFilesInterface>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  /** Styles will be ordered by this. */
  weight: Scalars['Int'];
};

export type FontStyleWithCorrespondingStyles = {
  __typename: 'FontStyleWithCorrespondingStyles';
  boldStyleId: Maybe<Scalars['String']>;
  cssRenderInfo: CssRenderInfo;
  fontMetrics: Maybe<FontMetricsInterface>;
  id: Scalars['ID'];
  italicStyleId: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pixelSize: Maybe<Scalars['Int']>;
  variableAxes: Maybe<Array<Maybe<FontVariationAxisInterface>>>;
  weight: Scalars['Int'];
};

export type FontStyleWithWords = {
  __typename: 'FontStyleWithWords';
  cssRenderInfo: CssRenderInfo;
  fontMetrics: Maybe<FontMetricsInterface>;
  id: Scalars['ID'];
  isItalic: Scalars['Boolean'];
  name: Scalars['String'];
  variableAxes: Maybe<Array<Maybe<FontVariationAxisInterface>>>;
  /** Styles will be ordered by this. */
  weight: Scalars['Int'];
  words: Array<SpecimenWord>;
};

export type FontSubfamilyInterface = {
  __typename: 'FontSubfamilyInterface';
  id: Scalars['ID'];
  /** Short name without family name, e.g. 'A' for 'Die Grotesk A' */
  name: Scalars['String'];
};

export type FontVariationAxisInterface = {
  __typename: 'FontVariationAxisInterface';
  created: Scalars['DateTime'];
  defaultValue: Scalars['Float'];
  id: Scalars['ID'];
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  tag: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type FontVariationInstanceAxisValueInterface = {
  __typename: 'FontVariationInstanceAxisValueInterface';
  tag: Scalars['String'];
  value: Scalars['Float'];
};

export type FontsInUseDetailPage = PageInterface & {
  __typename: 'FontsInUseDetailPage';
  aliasOf: Maybe<Page>;
  aliases: Array<Page>;
  ancestors: Array<PageInterface>;
  blogindexpage: Maybe<BlogIndexPage>;
  blogpage: Maybe<BlogPage>;
  blurbImage: CustomImage;
  body: Maybe<Array<Maybe<StreamFieldInterface>>>;
  categories: Maybe<Array<FontsInUseDetailPageMediaTag>>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  designerLinks: Maybe<Array<Maybe<StreamFieldInterface>>>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  feedImage: Maybe<CustomImage>;
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  fontFamilies: Maybe<Array<FontFamilyInterface>>;
  fontsinusedetailpage: Maybe<FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  lockedBy: Maybe<UserInterface>;
  mediaCount: Scalars['Int'];
  nextSiblings: Array<PageInterface>;
  noindex: Scalars['Boolean'];
  numchild: Scalars['Int'];
  owner: Maybe<UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  path: Scalars['String'];
  postDate: Scalars['DateTime'];
  previousSiblings: Array<PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  sitesRootedHere: Array<SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type FontsInUseDetailPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseDetailPagecategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseDetailPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseDetailPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseDetailPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseDetailPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseDetailPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type FontsInUseDetailPageMediaTag = {
  __typename: 'FontsInUseDetailPageMediaTag';
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type FontsInUseIndexPage = PageInterface & {
  __typename: 'FontsInUseIndexPage';
  aliasOf: Maybe<Page>;
  aliases: Array<Page>;
  ancestors: Array<PageInterface>;
  blogindexpage: Maybe<BlogIndexPage>;
  blogpage: Maybe<BlogPage>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  fontsinusedetailpage: Maybe<FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  lockedBy: Maybe<UserInterface>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  sitesRootedHere: Array<SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type FontsInUseIndexPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseIndexPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseIndexPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseIndexPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseIndexPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type FontsInUseIndexPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum FontsSpecimenConfigLetterCaseChoices {
  /** lower case */
  LOWER_CASE = 'LOWER_CASE',
  /** Sentence case */
  SENTENCE_CASE = 'SENTENCE_CASE',
  /** Title Case */
  TITLE_CASE = 'TITLE_CASE',
  /** unAltered */
  UNALTERED = 'UNALTERED',
  /** UPPER CASE */
  UPPER_CASE = 'UPPER_CASE'
}

/** An enumeration. */
export enum FontsSpecimenConfigSpecimenTypeChoices {
  /** BIG */
  BIG = 'BIG',
  /** MEDIUM */
  MEDIUM = 'MEDIUM',
  /** SMALL */
  SMALL = 'SMALL'
}

export type HomePage = PageInterface & {
  __typename: 'HomePage';
  aliasOf: Maybe<Page>;
  aliases: Array<Page>;
  ancestors: Array<PageInterface>;
  blogindexpage: Maybe<BlogIndexPage>;
  blogpage: Maybe<BlogPage>;
  campaigns: Maybe<Array<HomePageCampaign>>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  featuredBlogPosts: Maybe<Array<Maybe<BlogPage>>>;
  featuredFonts: Maybe<Array<FontFamilyGroupInterface>>;
  featuredInUsePosts: Maybe<Array<Maybe<FontsInUseDetailPage>>>;
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  fontsinusedetailpage: Maybe<FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  lockedBy: Maybe<UserInterface>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  sitesRootedHere: Array<SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type HomePageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagecampaignsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagefeaturedBlogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagefeaturedInUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type HomePageCampaign = {
  __typename: 'HomePageCampaign';
  campaign: CampaignInterface;
  fontFamilyGroup: FontFamilyGroupInterface;
  id: Maybe<Scalars['ID']>;
  sortOrder: Maybe<Scalars['Int']>;
};

export type InvoiceInterface = {
  __typename: 'InvoiceInterface';
  id: Scalars['ID'];
};

/** An enumeration. */
export enum KlimcartOrderStatusChoices {
  /** Delivered */
  DELIVERED = 'DELIVERED',
  /** New */
  NEW = 'NEW'
}

/** An enumeration. */
export enum KlimcartOrderUpgradeRequestStatusChoices {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** In progress */
  INVOICED = 'INVOICED',
  /** New */
  NEW = 'NEW'
}

export type LicenceTierInput = {
  contractDetails?: InputMaybe<Scalars['String']>;
  licenceSubject?: InputMaybe<Scalars['String']>;
  licenceTypeId: Scalars['ID'];
  tierId: Scalars['ID'];
};

/** Licence type IDs */
export enum LicenceTypeId {
  AD = 'AD',
  APP = 'APP',
  BROADCAST = 'BROADCAST',
  DESKTOP = 'DESKTOP',
  OEM = 'OEM',
  TEST = 'TEST',
  UDLA = 'UDLA',
  WEB = 'WEB'
}

export type LicenceTypeInterface = {
  __typename: 'LicenceTypeInterface';
  contractDetailsLabel: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** Denotes whether this licence type can be purchased using the self-service cart checkout on the website. If not, then this licence type will only be available in the CMS. */
  isAvailableViaCart: Scalars['Boolean'];
  licenceSubjectLabel: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tieredLicensing: Array<TieredLicensingInterface>;
};

export type LineItemInterface = {
  __typename: 'LineItemInterface';
  description: Maybe<Scalars['String']>;
  font: Maybe<FontProductInterface>;
  fontLicenceType: Maybe<LicenceTypeInterface>;
  fontSizeMultiplier: Scalars['Float'];
  id: Scalars['ID'];
  isRefunded: Scalars['Boolean'];
  price: Scalars['Float'];
  productName: Maybe<Scalars['String']>;
  productSubtitle: Maybe<Scalars['String']>;
  type: LineItemType;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  upgradedOrderNumbers: Array<Scalars['String']>;
};

/** An enumeration. */
export enum LineItemType {
  CUSTOM = 'CUSTOM',
  GOODS = 'GOODS',
  OTHER = 'OTHER',
  RETAIL = 'RETAIL',
  UPGRADE = 'UPGRADE'
}

export type LoginWithCodeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
};

export type LoginWithCodeMutationPayload = {
  __typename: 'LoginWithCodeMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  code: Scalars['String'];
  errors: Maybe<Array<Maybe<ErrorType>>>;
  user: Maybe<UserInterface>;
};

export type LogoutMutation = {
  __typename: 'LogoutMutation';
  ok: Maybe<Scalars['Boolean']>;
  user: Maybe<UserInterface>;
};

export type MediumSpecimenSet = {
  __typename: 'MediumSpecimenSet';
  /** Note that the following are always enabled (hard-coded): kern, liga, clig, calt */
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontSize: Scalars['Float'];
  fontStyles: Array<FontStyleWithCorrespondingStyles>;
  letterSpacing: Scalars['Float'];
  lineHeight: Scalars['Float'];
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Likelihood that a random OpenType feature will be applied to a specimen, expressed as a percentage of total specimens on the page. E.g. 25% will mean 1 in 4 Big, Medium or Small specimens on the page will have a random feature applied. */
  randomOpentypeLikelihood: Scalars['Int'];
  sentences: Array<Scalars['String']>;
  /** How many specimens are displayed for each font style within the font family. Can be set to 0, which will mean no specimens will show at all. */
  specimensPerFontStyle: Scalars['Int'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Cart mutation that works on the current user in session. */
  accountUserDetails: Maybe<AccountUserDetailsMutationPayload>;
  applySharedCart: Maybe<ApplySharedCartMutation>;
  /**
   * Mutation that creates/updates a Stripe PaymentIntent and returns a client secret
   * that enables Stripe.js to put a payment transaction through.
   */
  cartGetStripeClientSecret: Maybe<CartGetStripeClientSecret>;
  cartSetBillingCountry: Maybe<CartSetBillingCountryMutationPayload>;
  cartSetCheckoutDetails: Maybe<CartSetCheckoutDetailsMutationPayload>;
  cartSetExtraTierFields: Maybe<CartSetExtraTierFieldsMutation>;
  /**
   * This mutation will ensure that the current session cart has exactly
   * the fonts and licences that were passed as arguments. I.e. the entire cart
   * item/licence state is represented by the arguments.
   */
  cartUpdate: Maybe<CartUpdateMutation>;
  deleteSpecimen: Maybe<DeleteSpecimenMutation>;
  loginWithCode: Maybe<LoginWithCodeMutationPayload>;
  logout: Maybe<LogoutMutation>;
  newCart: Maybe<NewCartMutation>;
  newsletterSignup: Maybe<NewsletterSignupMutationPayload>;
  opentypeFeature: Maybe<FontFamilyOpenTypeFeatureMutationPayload>;
  orderUpgradeRequest: Maybe<OrderUpgradeRequestMutationPayload>;
  requestLoginCode: Maybe<RequestMagicLoginLinkMutationPayload>;
  revertLogin: Maybe<RevertLoginMutation>;
  shareCart: Maybe<ShareCartMutation>;
  specimen: Maybe<SpecimenMutationPayload>;
  testFontsDownload: Maybe<TestFontsDownloadMutationPayload>;
};


export type MutationaccountUserDetailsArgs = {
  input: AccountUserDetailsMutationInput;
};


export type MutationapplySharedCartArgs = {
  sharedCartId: Scalars['ID'];
};


export type MutationcartGetStripeClientSecretArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
};


export type MutationcartSetBillingCountryArgs = {
  input: CartSetBillingCountryMutationInput;
};


export type MutationcartSetCheckoutDetailsArgs = {
  input: CartSetCheckoutDetailsMutationInput;
};


export type MutationcartSetExtraTierFieldsArgs = {
  extraTierFields: Array<TierExtraFieldInput>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
};


export type MutationcartUpdateArgs = {
  fontProducts: Array<FontProductInput>;
  licenceTiers: Array<LicenceTierInput>;
};


export type MutationdeleteSpecimenArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationloginWithCodeArgs = {
  input: LoginWithCodeMutationInput;
};


export type MutationnewsletterSignupArgs = {
  input: NewsletterSignupMutationInput;
};


export type MutationopentypeFeatureArgs = {
  input: FontFamilyOpenTypeFeatureMutationInput;
};


export type MutationorderUpgradeRequestArgs = {
  input: OrderUpgradeRequestMutationInput;
};


export type MutationrequestLoginCodeArgs = {
  input: RequestMagicLoginLinkMutationInput;
};


export type MutationspecimenArgs = {
  input: SpecimenMutationInput;
};


export type MutationtestFontsDownloadArgs = {
  input: TestFontsDownloadMutationInput;
};

export type NewCartMutation = {
  __typename: 'NewCartMutation';
  cart: Maybe<CartInterface>;
  ok: Maybe<Scalars['Boolean']>;
};

export type NewsletterSignupMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type NewsletterSignupMutationPayload = {
  __typename: 'NewsletterSignupMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors: Maybe<Array<Maybe<EnumErrorType>>>;
};

/** An enumeration. */
export enum OpenTypeFeature {
  /** All small caps */
  C2SC = 'C2SC',
  /** Capital forms */
  CASE = 'CASE',
  /** Discretionary ligatures */
  DLIG = 'DLIG',
  /** Fractions */
  FRAC = 'FRAC',
  /** Ordinals */
  ORDN = 'ORDN',
  /** Lining numerals */
  PNUM_LNUM = 'PNUM_LNUM',
  /** Old-style numerals */
  PNUM_ONUM = 'PNUM_ONUM',
  /** Inferiors */
  SINF = 'SINF',
  /** Small caps */
  SMCP = 'SMCP',
  /** Stylistic set 01 */
  SS01 = 'SS01',
  /** Stylistic set 02 */
  SS02 = 'SS02',
  /** Stylistic set 03 */
  SS03 = 'SS03',
  /** Stylistic set 04 */
  SS04 = 'SS04',
  /** Stylistic set 05 */
  SS05 = 'SS05',
  /** Stylistic set 06 */
  SS06 = 'SS06',
  /** Stylistic set 07 */
  SS07 = 'SS07',
  /** Stylistic set 08 */
  SS08 = 'SS08',
  /** Stylistic set 09 */
  SS09 = 'SS09',
  /** Stylistic set 10 */
  SS10 = 'SS10',
  /** Stylistic set 11 */
  SS11 = 'SS11',
  /** Stylistic set 12 */
  SS12 = 'SS12',
  /** Stylistic set 13 */
  SS13 = 'SS13',
  /** Stylistic set 14 */
  SS14 = 'SS14',
  /** Stylistic set 15 */
  SS15 = 'SS15',
  /** Stylistic set 16 */
  SS16 = 'SS16',
  /** Stylistic set 17 */
  SS17 = 'SS17',
  /** Stylistic set 18 */
  SS18 = 'SS18',
  /** Stylistic set 19 */
  SS19 = 'SS19',
  /** Stylistic set 20 */
  SS20 = 'SS20',
  /** Superiors */
  SUPS = 'SUPS',
  /** Swashes */
  SWSH = 'SWSH',
  /** Tabular lining numerals */
  TNUM_LNUM = 'TNUM_LNUM',
  /** Tabular old-style numerals */
  TNUM_ONUM = 'TNUM_ONUM',
  /** Slashed zero */
  ZERO = 'ZERO'
}

export type OrderInterface = {
  __typename: 'OrderInterface';
  account: AccountInterface;
  /** Upgrade request for this order—if any—that hasn't been completed yet. */
  activeUpgradeRequest: Maybe<OrderUpgradeRequestInterface>;
  cart: CartInterface;
  date: Scalars['DateTime'];
  downloadFilename: Maybe<Scalars['String']>;
  downloadHasUpdate: Maybe<Scalars['Boolean']>;
  downloadLastModified: Maybe<Scalars['DateTime']>;
  downloadUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceUrl: Maybe<Scalars['String']>;
  orderNumber: Scalars['String'];
  status: KlimcartOrderStatusChoices;
  storageDownloadUrl: Maybe<Scalars['String']>;
};

export type OrderUpgradeRequestInterface = {
  __typename: 'OrderUpgradeRequestInterface';
  /** Customer's description of what to update and how. */
  details: Scalars['String'];
  id: Scalars['ID'];
  invoice: Maybe<InvoiceInterface>;
  licenceAppName: Maybe<Scalars['String']>;
  licenceWebDomainName: Maybe<Scalars['String']>;
  status: KlimcartOrderUpgradeRequestStatusChoices;
};

export type OrderUpgradeRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Customer's description of what to update and how. */
  details: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  licenceAppName?: InputMaybe<Scalars['String']>;
  licenceWebDomainName?: InputMaybe<Scalars['String']>;
  order: Scalars['ID'];
};

export type OrderUpgradeRequestMutationPayload = {
  __typename: 'OrderUpgradeRequestMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  errors: Array<ErrorType>;
  order: Maybe<OrderInterface>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type Page = PageInterface & {
  __typename: 'Page';
  aliasOf: Maybe<Page>;
  aliases: Array<Page>;
  ancestors: Array<PageInterface>;
  blogindexpage: Maybe<BlogIndexPage>;
  blogpage: Maybe<BlogPage>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  fontsinusedetailpage: Maybe<FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  lockedBy: Maybe<UserInterface>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  sitesRootedHere: Array<SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type PageInterface = {
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  nextSiblings: Array<PageInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<PageInterface>;
  previousSiblings: Array<PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type PageInterfaceancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfacechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfacedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfacenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfacepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfacesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type PreviewSpecimenSet = {
  __typename: 'PreviewSpecimenSet';
  bigSpecimenSet: Maybe<BigSpecimenSet>;
  canBeProcessed: Scalars['Boolean'];
  /** Specimens will consist roughly of this amount of characters. Don't make this number too large as it will significantly impact page load size. */
  characterCount: Scalars['Int'];
  /** +/- character count tolerance. If Character Count is 100 and Character Count Tolerance is 20 then all specimens will be 80–120 characters in length. */
  characterCountTolerance: Scalars['Int'];
  /** Number of columns */
  columns: Scalars['Int'];
  /** Secondary number of columns. If greater than zero a second specimen will be rendered below the main specimen, with altered column count. */
  columnsSecondary: Scalars['Int'];
  created: Scalars['DateTime'];
  /** Note that the following are always enabled (hard-coded): kern, liga, clig, calt */
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontFamily: FontFamilyInterface;
  /** Font size in vw (viewport width) units. */
  fontSize: Scalars['Decimal'];
  /** The secondary specimen's font size can be altered here. */
  fontSizeSecondary: Scalars['Decimal'];
  /** Which font styles to display specimens for. */
  fontStyles: Array<FontStyleWithCorrespondingStyles>;
  hasWordsToBeProcessed: Scalars['Boolean'];
  /** If checked this specimen config will show publicly on the site. */
  isActive: Scalars['Boolean'];
  isProcessed: Scalars['Boolean'];
  /** This will be True while this config is being actively processed, to prevent it from being picked up multiple times. */
  isProcessing: Scalars['Boolean'];
  /** Fix a particular letter case for all specimens. Unaltered keeps the case as taken from the original source. */
  letterCase: FontsSpecimenConfigLetterCaseChoices;
  /** Letter spacing to apply to all specimens. */
  letterSpacing: Scalars['Decimal'];
  /** The specimen will take up this many lines (rows). Don't make this number too large as it will significantly impact page load size. */
  lineCount: Scalars['Int'];
  /** The secondary specimen will take up this many lines (rows). */
  lineCountSecondary: Scalars['Int'];
  /** Line height to apply to all specimens. */
  lineHeight: Scalars['Decimal'];
  /** Maximum amount of processed words to calculate per font style and per random OpenType feature. The higher this number the longer processing will take. The resulting corpus size will be: (max. processed words) x (font style count) x (random OpenType feature count) */
  maxProcessedWords: Scalars['Int'];
  mediumSpecimenSet: Maybe<MediumSpecimenSet>;
  modified: Scalars['DateTime'];
  processedWords: Array<SpecimenWord>;
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Likelihood that a random OpenType feature will be applied to a specimen, expressed as a percentage of total specimens on the page. E.g. 25% will mean 1 in 4 Big, Medium or Small specimens on the page will have a random feature applied. */
  randomOpentypeLikelihood: Scalars['Int'];
  /** A word that is used as reference for specimen word width. Other specimens will try to match its width. */
  referenceWord: Scalars['String'];
  referenceWordCalculatedWidth: Maybe<Scalars['Int']>;
  /** Font Style that will be used to calculate the reference word width. */
  referenceWordFontStyle: Maybe<FontStyleWithCorrespondingStyles>;
  smallSpecimenSet: Maybe<SmallSpecimenSet>;
  specimenType: FontsSpecimenConfigSpecimenTypeChoices;
  /** How many specimens are displayed for each font style within the font family. Can be set to 0, which will mean no specimens will show at all. */
  specimensPerFontStyle: Scalars['Int'];
  uuid: Scalars['UUID'];
  /** Values between 0.005 (0.5%) and 0.02 (2%) seem to work best. This is negative tolerance, down from the width of the Reference Word. */
  widthTolerance: Scalars['Decimal'];
  /** Number of words at the start of the specimen that are to be set in Small Cap (smcp). */
  wordsInSmallCaps: Scalars['Int'];
};

export type ProductFontIds = {
  __typename: 'ProductFontIds';
  fontFamilyId: Scalars['ID'];
  fontStyleIds: Array<Scalars['ID']>;
};

export type PublicConfigInterface = {
  __typename: 'PublicConfigInterface';
  /** Whether the API is available and up. */
  apiIsUp: Scalars['Boolean'];
  /** Licence type IDs */
  licenceTypeIds: Array<LicenceTypeId>;
};

export type Query = {
  __typename: 'Query';
  bigSpecimenSet: Maybe<BigSpecimenSet>;
  cart: Maybe<CartInterface>;
  config: PublicConfigInterface;
  debug: Maybe<DjangoDebug>;
  invoiceNumberFromId: Maybe<Scalars['String']>;
  isInvoicePaid: Scalars['Boolean'];
  mediumSpecimenSet: Maybe<MediumSpecimenSet>;
  orderFromPaymentIntent: Maybe<OrderInterface>;
  previewSpecimenSet: Maybe<PreviewSpecimenSet>;
  smallSpecimenSet: Maybe<SmallSpecimenSet>;
  user: Maybe<UserInterface>;
};


export type QuerybigSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type QuerycartArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
};


export type QueryinvoiceNumberFromIdArgs = {
  invoiceId: Scalars['String'];
};


export type QueryisInvoicePaidArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
};


export type QuerymediumSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type QueryorderFromPaymentIntentArgs = {
  paymentIntentId?: InputMaybe<Scalars['ID']>;
};


export type QuerypreviewSpecimenSetArgs = {
  fontFamily: Scalars['ID'];
  specimenConfig: Scalars['ID'];
};


export type QuerysmallSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};

export type RequestMagicLoginLinkMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** URI to forward the user to upon successful authentication. */
  next?: InputMaybe<Scalars['String']>;
  /** Username/email to fetch a login code for. */
  username: Scalars['String'];
};

export type RequestMagicLoginLinkMutationPayload = {
  __typename: 'RequestMagicLoginLinkMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
  /** URI to forward the user to upon successful authentication. */
  next: Maybe<Scalars['String']>;
  username: Maybe<Scalars['String']>;
};

export type RevertLoginMutation = {
  __typename: 'RevertLoginMutation';
  next: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
};

export type ShareCartMutation = {
  __typename: 'ShareCartMutation';
  sharedCartId: Scalars['ID'];
};

export type SiteObjectType = {
  __typename: 'SiteObjectType';
  hostname: Scalars['String'];
  id: Scalars['ID'];
  /** If true, this site will handle requests for all other hostnames that do not have a site entry of their own */
  isDefaultSite: Scalars['Boolean'];
  page: Maybe<PageInterface>;
  pages: Array<PageInterface>;
  /** Set this to something other than 80 if you need a specific port number to appear in URLs (e.g. development on port 8000). Does not affect request handling (so port forwarding still works). */
  port: Scalars['Int'];
  rootPage: Page;
  /** Human-readable name for the site. */
  siteName: Scalars['String'];
};


export type SiteObjectTypepageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type SiteObjectTypepagesArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type SmallSpecimenSet = {
  __typename: 'SmallSpecimenSet';
  /** Specimens will consist roughly of this amount of characters. Don't make this number too large as it will significantly impact page load size. */
  characterCount: Scalars['Int'];
  /** Number of columns */
  columns: Scalars['Int'];
  /** Secondary number of columns. If greater than zero a second specimen will be rendered below the main specimen, with altered column count. */
  columnsSecondary: Scalars['Int'];
  /** Note that the following are always enabled (hard-coded): kern, liga, clig, calt */
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontSize: Scalars['Float'];
  fontSizeSecondary: Scalars['Float'];
  fontStyles: Array<FontStyleWithCorrespondingStyles>;
  letterSpacing: Scalars['Float'];
  /** The specimen will take up this many lines (rows). Don't make this number too large as it will significantly impact page load size. */
  lineCount: Scalars['Int'];
  /** The secondary specimen will take up this many lines (rows). */
  lineCountSecondary: Scalars['Int'];
  lineHeight: Scalars['Float'];
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Likelihood that a random OpenType feature will be applied to a specimen, expressed as a percentage of total specimens on the page. E.g. 25% will mean 1 in 4 Big, Medium or Small specimens on the page will have a random feature applied. */
  randomOpentypeLikelihood: Scalars['Int'];
  sentences: Array<Scalars['String']>;
  /** Number of words at the start of the specimen that are to be set in Small Cap (smcp). */
  wordsInSmallCaps: Scalars['Int'];
};

/** An enumeration. */
export enum SpecimenFontFamilyOpenTypeFeatureTypeChoices {
  /** All small caps */
  C2SC = 'C2SC',
  /** Capital forms */
  CASE = 'CASE',
  /** Discretionary ligatures */
  DLIG = 'DLIG',
  /** Fractions */
  FRAC = 'FRAC',
  /** Ordinals */
  ORDN = 'ORDN',
  /** Lining numerals */
  PNUM_LNUM = 'PNUM_LNUM',
  /** Old-style numerals */
  PNUM_ONUM = 'PNUM_ONUM',
  /** Inferiors */
  SINF = 'SINF',
  /** Alternates */
  SSXX = 'SSXX',
  /** Superiors */
  SUPS = 'SUPS',
  /** Swashes */
  SWSH = 'SWSH',
  /** Tabular lining numerals */
  TNUM_LNUM = 'TNUM_LNUM',
  /** Tabular old-style numerals */
  TNUM_ONUM = 'TNUM_ONUM',
  /** Slashed zero */
  ZERO = 'ZERO'
}

export type SpecimenInterface = {
  __typename: 'SpecimenInterface';
  columns: Scalars['Int'];
  cssRenderInfo: Maybe<CssRenderInfo>;
  fontSize: Scalars['Decimal'];
  fontStyleName: Scalars['String'];
  id: Scalars['ID'];
  letterSpacing: Scalars['Decimal'];
  lineHeight: Scalars['Decimal'];
  specimenType: Maybe<SpecimenTypeChoice>;
  state: Scalars['String'];
  textAlign: Scalars['String'];
};

export type SpecimenMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  columns: Scalars['Int'];
  fontSize: Scalars['Decimal'];
  fontStyle: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  letterSpacing: Scalars['Decimal'];
  lineHeight: Scalars['Decimal'];
  state: Scalars['String'];
  textAlign: Scalars['String'];
};

export type SpecimenMutationPayload = {
  __typename: 'SpecimenMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  errors: Array<ErrorType>;
  specimen: Maybe<SpecimenInterface>;
};

/** Type of Specimen */
export enum SpecimenTypeChoice {
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export type SpecimenWord = {
  __typename: 'SpecimenWord';
  /** Proxy for easier querying */
  content: Scalars['String'];
  contentAscii: Scalars['String'];
  opentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Calculated width */
  width: Scalars['Int'];
};

export type StreamFieldInterface = {
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type StylisticSetNameInterface = {
  __typename: 'StylisticSetNameInterface';
  name: Scalars['String'];
  openTypeFeature: OpenTypeFeature;
};

export type TagObjectType = {
  __typename: 'TagObjectType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TestFontsDownloadMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type TestFontsDownloadMutationPayload = {
  __typename: 'TestFontsDownloadMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  downloadUrl: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  emailOptIn: Maybe<Scalars['Boolean']>;
  errors: Maybe<Array<Maybe<ErrorType>>>;
};

export type TierExtraFieldErrorType = {
  __typename: 'TierExtraFieldErrorType';
  error: ErrorType;
  licenceTypeId: Scalars['ID'];
};

export type TierExtraFieldInput = {
  licenceSubject: Scalars['String'];
  licenceTypeId: Scalars['ID'];
};

export type TierInterface = {
  __typename: 'TierInterface';
  amount: Scalars['String'];
  hasContractDetailsField: Scalars['Boolean'];
  hasLicenceSubjectField: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** Denotes if this is a tier that is subject to an Unlimited Licensing Agreement. */
  isUnlimited: Scalars['Boolean'];
  licenceType: LicenceTypeInterface;
  multiplier: Scalars['Float'];
  tieredLicence: TieredLicensingInterface;
  title: Scalars['String'];
  titleAbbrev: Scalars['String'];
};

export type TieredLicensingInterface = {
  __typename: 'TieredLicensingInterface';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  licenceType: LicenceTypeInterface;
  tiers: Array<TierInterface>;
  title: Scalars['String'];
  unitStr: Scalars['String'];
  unitStrAbbrev: Scalars['String'];
  unitStrAbbrevPlural: Scalars['String'];
  unitStrPlural: Scalars['String'];
};

export type UserInterface = {
  __typename: 'UserInterface';
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Maybe<Scalars['String']>;
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Maybe<CountryChoices>;
  billingPostcode: Maybe<Scalars['String']>;
  billingState: Maybe<Scalars['String']>;
  billingVatNumber: Maybe<Scalars['String']>;
  canRevert: Scalars['Boolean'];
  email: Scalars['String'];
  emailOptIn: Scalars['Boolean'];
  fullName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  /** Order history */
  orders: Array<OrderInterface>;
};


export type UserInterfaceordersArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type VimeoVideoFileInterface = {
  __typename: 'VimeoVideoFileInterface';
  height: Scalars['Int'];
  id: Scalars['ID'];
  src: Scalars['String'];
  type: Scalars['String'];
  video: VimeoVideoInterface;
  width: Scalars['Int'];
};

export type VimeoVideoInterface = {
  __typename: 'VimeoVideoInterface';
  embedUrl: Scalars['String'];
  files: Array<VimeoVideoFileInterface>;
  height: Scalars['Int'];
  id: Scalars['ID'];
  title: Scalars['String'];
  width: Scalars['Int'];
};

export type FontMetricsFragmentFragment = { __typename: 'FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number };

export type CssRenderInfoFragmentFragment = { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null };

export type FontVariationAxesFragmentFragment = { __typename: 'FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number };

export type CartFragmentFragment = { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> };

export type OrderFragmentFragment = { __typename: 'OrderInterface', id: string, orderNumber: string, date: any, downloadUrl: string | null, invoiceUrl: string | null, cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> }, activeUpgradeRequest: { __typename: 'OrderUpgradeRequestInterface', status: KlimcartOrderUpgradeRequestStatusChoices, details: string } | null };

export type UserFragmentFragment = { __typename: 'UserInterface', id: string, email: string, fullName: string | null, isAdmin: boolean, canRevert: boolean, emailOptIn: boolean, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null };

export type NewCartMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type NewCartMutationMutation = { newCart: { __typename: 'NewCartMutation', ok: boolean | null } | null };

export type OrderUpgradeRequestMutationMutationVariables = Exact<{
  input: OrderUpgradeRequestMutationInput;
}>;


export type OrderUpgradeRequestMutationMutation = { orderUpgradeRequest: { __typename: 'OrderUpgradeRequestMutationPayload', order: { __typename: 'OrderInterface', id: string, orderNumber: string, date: any, downloadUrl: string | null, invoiceUrl: string | null, cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> }, activeUpgradeRequest: { __typename: 'OrderUpgradeRequestInterface', status: KlimcartOrderUpgradeRequestStatusChoices, details: string } | null } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> }> } | null };

export type CartSetBillingCountryMutationMutationVariables = Exact<{
  input: CartSetBillingCountryMutationInput;
}>;


export type CartSetBillingCountryMutationMutation = { cartSetBillingCountry: { __typename: 'CartSetBillingCountryMutationPayload', cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> } } | null };

export type AccountUserDetailsMutationMutationVariables = Exact<{
  input: AccountUserDetailsMutationInput;
}>;


export type AccountUserDetailsMutationMutation = { accountUserDetails: { __typename: 'AccountUserDetailsMutationPayload', user: { __typename: 'UserInterface', id: string, email: string, fullName: string | null, isAdmin: boolean, canRevert: boolean, emailOptIn: boolean, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type LogoutMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutationMutation = { logout: { __typename: 'LogoutMutation', ok: boolean | null } | null };

export type RevertLoginMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type RevertLoginMutationMutation = { revertLogin: { __typename: 'RevertLoginMutation', ok: boolean | null, next: string | null } | null };

export type LoginWithCodeMutationMutationVariables = Exact<{
  input: LoginWithCodeMutationInput;
}>;


export type LoginWithCodeMutationMutation = { loginWithCode: { __typename: 'LoginWithCodeMutationPayload', user: { __typename: 'UserInterface', id: string, email: string, fullName: string | null, isAdmin: boolean, canRevert: boolean, emailOptIn: boolean, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RequestLoginCodeMutationMutationVariables = Exact<{
  input: RequestMagicLoginLinkMutationInput;
}>;


export type RequestLoginCodeMutationMutation = { requestLoginCode: { __typename: 'RequestMagicLoginLinkMutationPayload', errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ShareCartMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type ShareCartMutationMutation = { shareCart: { __typename: 'ShareCartMutation', sharedCartId: string } | null };

export type ApplySharedCartMutationMutationVariables = Exact<{
  sharedCartId: Scalars['ID'];
}>;


export type ApplySharedCartMutationMutation = { applySharedCart: { __typename: 'ApplySharedCartMutation', cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> } | null } | null };

export type UserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQueryQuery = { user: { __typename: 'UserInterface', id: string, email: string, fullName: string | null, isAdmin: boolean, canRevert: boolean, emailOptIn: boolean, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null } | null };

export type UserOrdersQueryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type UserOrdersQueryQuery = { user: { __typename: 'UserInterface', id: string, orders: Array<{ __typename: 'OrderInterface', id: string, orderNumber: string, date: any, downloadUrl: string | null, invoiceUrl: string | null, cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> }, activeUpgradeRequest: { __typename: 'OrderUpgradeRequestInterface', status: KlimcartOrderUpgradeRequestStatusChoices, details: string } | null }> } | null };

export type CartUpdateMutationMutationVariables = Exact<{
  fontProducts: Array<FontProductInput> | FontProductInput;
  licenceTiers: Array<LicenceTierInput> | LicenceTierInput;
}>;


export type CartUpdateMutationMutation = { cartUpdate: { __typename: 'CartUpdateMutation', cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> } } | null };

export type CartQueryQueryVariables = Exact<{
  invoiceNumber?: InputMaybe<Scalars['String']>;
}>;


export type CartQueryQuery = { cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> } | null };

export type IsInvoicePaidQueryQueryVariables = Exact<{
  invoiceNumber?: InputMaybe<Scalars['String']>;
}>;


export type IsInvoicePaidQueryQuery = { isInvoicePaid: boolean };

export type InvoiceNumberFromIdQueryQueryVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type InvoiceNumberFromIdQueryQuery = { invoiceNumberFromId: string | null };

export type PublicConfigQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicConfigQueryQuery = { config: { __typename: 'PublicConfigInterface', apiIsUp: boolean } };

export type PreviewSpecimenSetQueryQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  specimenConfig: Scalars['ID'];
}>;


export type PreviewSpecimenSetQueryQuery = { previewSpecimenSet: { __typename: 'PreviewSpecimenSet', bigSpecimenSet: { __typename: 'BigSpecimenSet', lineHeight: number, letterSpacing: number, specimensPerFontStyle: number, referenceWordCalculatedWidth: number, fontStyles: Array<{ __typename: 'FontStyleWithWords', id: string, name: string, fontMetrics: { __typename: 'FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, words: Array<{ __typename: 'SpecimenWord', width: number, content: string, contentAscii: string, opentypeFeatures: Array<string> | null }>, variableAxes: Array<{ __typename: 'FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null, mediumSpecimenSet: { __typename: 'MediumSpecimenSet', fontSize: number, lineHeight: number, letterSpacing: number, fixedOpentypeFeatures: Array<string> | null, randomOpentypeFeatures: Array<string> | null, randomOpentypeLikelihood: number, specimensPerFontStyle: number, sentences: Array<string>, fontStyles: Array<{ __typename: 'FontStyleWithCorrespondingStyles', id: string, name: string, italicStyleId: string | null, boldStyleId: string | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontMetrics: { __typename: 'FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, variableAxes: Array<{ __typename: 'FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null, smallSpecimenSet: { __typename: 'SmallSpecimenSet', fontSize: number, lineHeight: number, letterSpacing: number, columns: number, fixedOpentypeFeatures: Array<string> | null, randomOpentypeFeatures: Array<string> | null, randomOpentypeLikelihood: number, wordsInSmallCaps: number, lineCount: number, columnsSecondary: number, fontSizeSecondary: number, lineCountSecondary: number, sentences: Array<string>, fontStyles: Array<{ __typename: 'FontStyleWithCorrespondingStyles', pixelSize: number | null, id: string, name: string, italicStyleId: string | null, boldStyleId: string | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontMetrics: { __typename: 'FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, variableAxes: Array<{ __typename: 'FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } | null };

export type NewsletterSignupMutationMutationVariables = Exact<{
  input: NewsletterSignupMutationInput;
}>;


export type NewsletterSignupMutationMutation = { newsletterSignup: { __typename: 'NewsletterSignupMutationPayload', errors: Array<{ __typename: 'EnumErrorType', field: string | null, messages: Array<ErrorCode> | null } | null> | null } | null };

export type TestFontsDownloadMutationMutationVariables = Exact<{
  input: TestFontsDownloadMutationInput;
}>;


export type TestFontsDownloadMutationMutation = { testFontsDownload: { __typename: 'TestFontsDownloadMutationPayload', downloadUrl: string | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CartGetStripeClientSecretMutationVariables = Exact<{
  invoiceNumber?: InputMaybe<Scalars['String']>;
}>;


export type CartGetStripeClientSecretMutation = { cartGetStripeClientSecret: { __typename: 'CartGetStripeClientSecret', invoiceIsPaid: boolean | null, clientSecret: string | null, cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> } | null } | null };

export type CartSetCheckoutDetailsMutationVariables = Exact<{
  extraTierFields: Array<TierExtraFieldInput> | TierExtraFieldInput;
  input: CartSetCheckoutDetailsMutationInput;
  invoiceNumber?: InputMaybe<Scalars['String']>;
}>;


export type CartSetCheckoutDetailsMutation = { cartSetExtraTierFields: { __typename: 'CartSetExtraTierFieldsMutation', errors: Array<{ __typename: 'TierExtraFieldErrorType', licenceTypeId: string, error: { __typename: 'ErrorType', field: string, messages: Array<string> } }> | null } | null, cartSetCheckoutDetails: { __typename: 'CartSetCheckoutDetailsMutationPayload', cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> }, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> }> } | null };

export type OrderFromPaymentIntentQueryQueryVariables = Exact<{
  paymentIntentId: Scalars['ID'];
}>;


export type OrderFromPaymentIntentQueryQuery = { orderFromPaymentIntent: { __typename: 'OrderInterface', status: KlimcartOrderStatusChoices, orderNumber: string, downloadUrl: string | null, account: { __typename: 'AccountInterface', user: { __typename: 'UserInterface', id: string, email: string, fullName: string | null, isAdmin: boolean, canRevert: boolean, emailOptIn: boolean, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null } }, cart: { __typename: 'CartInterface', id: string, amountSubtotal: number, amountSubtotalForFontsWithLicenceMultiplier: number, amountSubtotalConverted: number, amountTotal: number, amountTotalUsd: number, amountTax: number, amountTaxUsd: number, exchangeRate: number, taxRate: number, currency: CurrencyChoices | null, emailOptIn: boolean, userEmail: string | null, billingName: string | null, billingCompanyName: string | null, billingAddress1: string | null, billingAddress2: string | null, billingCity: string | null, billingState: string | null, billingPostcode: string | null, billingCountry: CountryChoices | null, billingVatNumber: string | null, billingPurchaseOrder: string | null, legacyBillingAddress: string | null, licensedForSomeoneElse: boolean, licensedToCompanyName: string | null, licensedToAddress1: string | null, licensedToAddress2: string | null, licensedToCity: string | null, licensedToState: string | null, licensedToPostcode: string | null, licensedToCountry: CountryChoices | null, licensedToVatNumber: string | null, legacyLicensedTo: string | null, isInvoice: boolean, invoiceId: string | null, invoiceNumber: string | null, invoiceExtraDescription: string | null, hasDownloadables: boolean, usesNativeCurrency: boolean, usesCurrencyConversion: boolean, nativeCurrency: CurrencyChoices | null, hasSimpleLicensing: boolean, hasFontlessItems: boolean, refundedAmount: number, licenceTiers: Array<{ __typename: 'CartTierInterface', id: string, licenceSubject: string | null, contractDetails: string | null, tier: { __typename: 'TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, hasContractDetailsField: boolean, hasLicenceSubjectField: boolean, licenceType: { __typename: 'LicenceTypeInterface', id: string, name: string, licenceSubjectLabel: string | null, contractDetailsLabel: string }, tieredLicence: { __typename: 'TieredLicensingInterface', id: string } } }>, items: Array<{ __typename: 'LineItemInterface', id: string, description: string | null, productName: string | null, productSubtitle: string | null, price: number, unitPrice: number, type: LineItemType, upgradedOrderNumbers: Array<string>, isRefunded: boolean, fontLicenceType: { __typename: 'LicenceTypeInterface', id: string } | null, font: { __typename: 'FontProductInterface', fontId: string, fontProductType: FontProductTypeChoice, fontSizeMultiplier: number, typographicRanking: number | null, cssRenderInfo: { __typename: 'CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontStyleIdsByFamilyId: Array<{ __typename: 'ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }> } | null }>, discounts: Array<{ __typename: 'DiscountInterface', id: string, type: DiscountType, amount: number, percentage: number, description: string | null }> } } | null };
